import React from "react";
import { Helmet } from "react-helmet-async";
import { buildMeta } from "./buildMeta";

const PageMeta = ({ title, description, path, image, keywords, jsonLd }) => {
  const meta = buildMeta({ title, description, path, image, keywords });

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="keywords" content={meta.keywords} />
      <link rel="canonical" href={meta.canonical} />

      <meta property="og:title" content={meta.og.title} />
      <meta property="og:description" content={meta.og.description} />
      <meta property="og:url" content={meta.og.url} />
      <meta property="og:image" content={meta.og.image} />
      <meta property="og:type" content={meta.og.type} />

      <meta name="twitter:card" content={meta.twitter.card} />
      <meta name="twitter:title" content={meta.twitter.title} />
      <meta name="twitter:description" content={meta.twitter.description} />
      <meta name="twitter:image" content={meta.twitter.image} />

      {jsonLd?.map((item, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
};

export default PageMeta;
